import * as React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Card, Container, Grid, Row, Spacer, Text } from '@nextui-org/react';
import {
  GetAllowedEmailsDocument,
  useGetAllowedEmailsQuery,
  useRemoveAllowedEmailMutation,
} from '@src/generated/hooks';
import { AppFullWidthContainer } from '@src/layouts/app/AppFullWidthContainer';
import { AppFullWidthLoader } from '../app/AppFullWidthLoader';
import { AppLoadingButton } from '../app/AppLoadingButton';

interface UsersListProps {}

/**
 * @name UsersList
 * @description tbd...
 */
export function UsersList(_props: UsersListProps) {
  // const {} = props

  // Hooks
  const [removingEmail, setRemovingEmail] = React.useState('');

  // GraphQL
  const { data, error, loading } = useGetAllowedEmailsQuery();
  const [removeAllowedEmailMutation] = useRemoveAllowedEmailMutation({
    refetchQueries: [{ query: GetAllowedEmailsDocument }],
  });

  // Setup
  const users = data?.devAllowedEmails;
  const errorLoading = error || !users;

  // Handlers
  const onRemoveUser = async (email: string) => {
    setRemovingEmail(email);
    await removeAllowedEmailMutation({
      variables: {
        email,
      },
    });
    setRemovingEmail('');
  };

  return (
    <AppFullWidthContainer>
      <AppFullWidthContainer>
        <Text h3 weight="bold">
          Users
        </Text>
      </AppFullWidthContainer>
      {loading && <AppFullWidthLoader />}
      {!loading && !errorLoading && (
        <Grid.Container gap={1} css={{ p: 0 }}>
          {users.map((user) => (
            <Grid key={user.id} xs={12}>
              <Card variant="bordered" css={{ w: '100%' }}>
                <Card.Body css={{ p: '$4' }}>
                  <Container fluid css={{ px: '$4' }}>
                    <Row justify="space-between" align="center">
                      <Text>{user.email}</Text>
                      <AppLoadingButton
                        color="error"
                        auto
                        onPress={() => onRemoveUser(user.email)}
                        loading={removingEmail === user.email}
                      >
                        <TrashIcon width={24} height={24} />
                      </AppLoadingButton>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Grid>
          ))}
        </Grid.Container>
      )}
      {!loading && errorLoading && (
        <Container>
          <Spacer y={3} />
          <Row justify="center">
            <Card css={{ mw: '400px' }}>
              <Card.Body>
                <Text color="error">
                  There was an error loading users. Try refreshing the page.
                </Text>
              </Card.Body>
            </Card>
          </Row>
        </Container>
      )}
    </AppFullWidthContainer>
  );
}
